const ThemePathPrefix: string = 'styles/theme/mapp.mvc-studio.variables.';

export const FilePaths = {
  LightTheme: `${ThemePathPrefix}light-theme.css`,
  DarkTheme: `${ThemePathPrefix}dark-theme.css`
};

export const DarkThemeKey: string = 'dark-theme';